import type { SVGProps } from 'react';

const SvgSum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 21H7c-.79 0-1.49-.45-1.82-1.17s-.21-1.55.32-2.14l4.97-5.68L5.5 6.33a1.98 1.98 0 0 1-.32-2.14C5.51 3.47 6.21 3.02 7 3.02h9c1.65 0 3 1.35 3 3v1c0 .55-.45 1-1 1s-1-.45-1-1v-1c0-.55-.45-1-1-1H7l4.97 5.68c.66.75.66 1.88 0 2.63L7 19.01h9c.55 0 1-.45 1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 1.65-1.35 3-3 3z"
    />
  </svg>
);
export default SvgSum;
